import React, { useContext, useEffect, useState } from 'react'
import { Link, useParams, useNavigate } from "react-router-dom"
import { Check, ChevronLeft, ShoppingCart } from "react-feather"
import Button from "@/components/Button"
import Loader from "@/components/Loader"
import api from '../api'
import { CartContext, UserContext } from '@/App'
import TypeButton from '../components/typeButton'
import StyleButton from '../components/styleButton'

export default function ProductDetailsPage() {
	const {user} = useContext(UserContext)
	const {cart, cartDispatch} = useContext(CartContext)
	const navigate = useNavigate()
	const { id } = useParams()
	const [product, setProduct] = useState(null)
	const [products, setProducts] = useState([])
	const [types, setTypes] = useState([])
	const [styles, setStyles] = useState([])
	const [activeIndex, setActiveIndex] = useState(0);
	const [selectedType, setSelectedType] = useState(null);
    const [selectedStyle, setSelectedStyle] = useState(null);
	// const imgPath = "https://images.pexels.com/photos/1852382/pexels-photo-1852382.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260;https://images.pexels.com/photos/594610/pexels-photo-594610.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260;https://images.pexels.com/photos/449977/pexels-photo-449977.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    const images = product?.imgPath.split(";") ?? [];

	// const images = product?.imgPath 
	// ? Array(3).fill(product?.imgPath) 
	// : [];

	useEffect(() => {
		(async () => {
			const resp = await api.fetchProduct(id)
			if (resp.status == "error") {
				return history.replace("/404")
			}
			console.log("product details",resp)
			setProduct(resp[0])
			setProducts(resp)
			const types = [...new Map(
				resp.filter(p => p.type_id != 0)
				.map(p => [p.type_id, { id: p.type_id, name: p.type }])).values()].reverse();
			setTypes(types)
			setSelectedType(types[0]?.id)
			const styles = [...new Map(
				resp.filter(p => p.style_id != 0)
				.map(p => [p.style_id, { id: p.style_id, name: p.style }])).values()];
			setStyles(styles)
			setSelectedStyle(styles[0]?.id)
			// setTypes([...new Set(resp?.map(p => p.type))]);
            // setStyles([...new Set(resp?.map(p => p.style))]);
		})()
	}, [id])

  const addToCart = async (product, quantity=1) => {
	console.log("product",product)
		if (user) {
			const resp = await api.addProductsToCart([{product:product, quantity}])
			if (resp) {
				cartDispatch({type: "ADD_PRODUCTS", payload: [{...product, quantity}]})
			}
    } else {
			cartDispatch({type: "ADD_PRODUCTS", payload: [{...product, quantity}]})
		}
  }

  useEffect (() => {
   (async () => {
	let filteredProduct = products

	if (selectedType && !selectedStyle){
     filteredProduct =  products.filter(p => p.type_id == selectedType)
	 console.log("filtered Type Products",filteredProduct)
    setStyles([...new Map(filteredProduct.filter(p => p.style_id != 0)
		.map(p => [p.style_id, { id: p.style_id, name: p.style }])).values()]);
	setSelectedStyle(styles[0]?.id)
	}else if (selectedType && selectedStyle){
	 filteredProduct =  products.filter(p => p.style_id == selectedStyle && p.type_id == selectedType)
	 console.log("filtered Style Products",filteredProduct)
	}

	if (filteredProduct.length == 0) {
     setSelectedStyle(null)
     return;
    }
	 setProduct(filteredProduct[0])
	//  setProducts(filteredProduct)
   })()
  }, [selectedType,selectedStyle])

	if (!product) return <Loader /> 
        console.log("types",types);
		console.log("styles",styles);

	return (
		<main className="relative mb-20">
			<div className="grid grid-cols-1 md:grid-cols-2 py-8 px-4 gap-8">
			{/* Slider Section */}
			<div className="flex flex-col items-center">
			 <div className="relative mt-8 ml-4 w-[5oopx] h-[500px] flex items-center justify-center bg-gray-100 rounded-lg">
				<img 
				src={images[activeIndex]} 
				alt={`Product${activeIndex}`}
				className='object-contain max-h-full rounded'
				 />
				 {images.length >1 && (
					<>
					<Button
					onClick={() => 
						setActiveIndex((prev) =>
							prev == 0 ? images.length -1 : prev - 1
						)
					}
					 className="absolute left-3 top-1/2 -translate-y-1/2 bg-black text-white text-2xl px-2 py-1 rounded-full hover:bg-gray-500 transition"
					>
                    ❮
					</Button>
					<Button
					onClick={() => 
						setActiveIndex((prev) =>
							prev == images.length -1 ? 0 : prev + 1
						)
					}
					className="absolute right-3 top-1/2 -translate-y-1/2 bg-black text-white text-2xl px-2 py-1 rounded-full hover:bg-gray-500 transition"
					>
					❯
					</Button>
					</>
				 )}
			 </div>
             
			{/* Thumbnalis */}
             <div className="mt-4 flex gap-3 justify-center">
				{images.map((img, i) => (
                <img
				key={i} 
				src={img} 
				className={`w-16 h-16 object-cover rounded cursor-pointer border-2 ${
				  i === activeIndex
					? "border-gray-500"
					: "border-gray-300 opacity-70"
				}`} 
				onClick={()=> setActiveIndex(i)}
				/>  
				))}
			 </div>
             </div>

				{/* <section className="flex items-center max-h-2xl overflow-hidden my-10 sm:mx-0 border border-gray-300 rounded-lg">
					<img
						className="object-cover"
						src={product.imgPath} 
					/>
				</section> */}
				
				<section className="flex flex-col justify-center space-y-6 text-gray-600">
					<h2 className="text-4xl text-gray-800">{product.iName}</h2>
					{product.iDesc?<p className="text-xl">{product.iDesc}</p>:<></>}
					{/* <span className="text-2xl font-medium">₹{product.tranRate}</span> */}

					{product?.discountPercent == 0
					?(
						<p className="text-2xl font-semibold text-[black]">
					    ₹{product?.rate.toFixed(2)}
					    </p>
					)
					:(
						<p className="text-2xl font-semibold">
						<s>₹{product?.rate.toFixed(2)}</s>  ({product?.discountPercent}% OFF)
						</p>
					)
					}

					{product?.discountPercent !== 0
					?(
						<p className="text-2xl font-semibold text-[black]">
						₹{product?.tranRate.toFixed(2)}
					</p>
					):
					<span></span>
					}

					<div className="flex gap-2 mb-4">
					{types.map((t) => (
						<TypeButton
						key={t.id}
						value={t.name}
						selected={selectedType == t.id}
						onClick={() => setSelectedType(t.id)}
						/>
					))}
					</div>

					<div className="flex gap-2 mb-4">
					{styles.map((s) => (
						<StyleButton
						key={s.id}
						value={s.name}
						selected={selectedStyle == s.id}
						onClick={() => setSelectedStyle(s.id)}
						/>
					))}
					</div>

					{cart?.products?.some(p => p.itemId == id) ? (
						<Link to="/cart">
							<Button link className="sm:max-w-xs text-base">
								<Check className="mr-2" />
								<span>Added to Cart</span>
							</Button>
						</Link>
					) : (
						<Button className="sm:max-w-xs text-base"onClick={() => addToCart(product)}>
							<ShoppingCart className="opacity-80 mr-4" />
							<span>Add to Cart</span>
						</Button>
					)}
				</section>
			</div>
			<Button 
				onClick={() => navigate(-1)}
				className="absolute top-0 text-lg" 
				secondary
			><ChevronLeft className="mr-2" /> Back
			</Button>
		</main>
	)
}